export enum RoleList {
  Author = 'author',
  Member = 'member',
}

export enum ViewCommentMode {
  View = 'View',
  Edit = 'Edit',
}

export enum ShowCommentState {
  Hidden = 'hidden',
  ShowMore = 'showMore',
  Show = 'show',
}
